import React, { useEffect, useRef, useState } from "react";
import TableContainer from "../../components/table/table";
import { useDispatch, useSelector } from "react-redux";
import { getAllRFTSDetail } from "../../store/actions/rfts";
import moment from "moment";
import { filterName } from "../../utils/Utils";
import ExportButton from "../../components/exportButton";
import { getReports } from "../../store/actions/report";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import TextAreaFields from "../../components/textAreaFields";
import ButtonContainer from "../../components/buttonContainer";
import { useForm } from "react-hook-form";

const RftsDetailView = (props) => {
    const { data } = props
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [commentsList, setCommentsList] = useState([])

    const [isCommentLoading, setIsCommentLoading] = useState(false);

    const { packSizeList, medicationTypeList } = useSelector(state => state.filler)

    const [Products, setProducts] = useState([])
    const [isExportLoading, setIsExportLoading] = useState(false);
    const { user } = useSelector(state => state.auth)

    const tableHeader = ['DIN Number', 'Product Name', 'Medication', 'Strenght', 'Requested(qty)', 'Pack Size', 'Expiry', 'Received(qty)']
    const verifyParam = ['diN_Master', 'productName', 'dosageValue', 'mg', 'requiredQuantity', 'packSizeValue', 'expiry', 'productQtySent']


    const defaultValues = useForm({
        defaultValues: {
            comment: "",
        },
    });

    const {
        control,
        handleSubmit,
        setError,
        clearErrors,
        watch,
        reset,
        resetField,
        getValues,
        formState: { errors },
    } = defaultValues;

    const scrollRef = useRef(null);

    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
    }, [commentsList]);

    useEffect(() => {
        getRFTSDetail()
        getComments()
    }, [])

    const getRFTSDetail = () => {
        setIsLoading(true)
        setProducts([])
        let obj = {
            "sid": null,
            "lid": null,
            "reqInfo": null,
            "msgType": "GETALLRFTSBYRFTSID",
            "data": { "RFTS_ID": data?.rftsid },
            "debug": null,
            "token": null
        };

        dispatch(getAllRFTSDetail(obj)).then(res => {
            setIsLoading(false)
            const result = res.payload.data.reduce((acc, current) => {
                const product = acc.find(p => p.product_ID === current.product_ID);
                if (product) {
                    product?.records?.push({ ...current, sentQty: "", expiry: moment(current.expiryTo).format('YYYY-MM-DD') });
                } else {
                    acc.push({
                        product_ID: current.product_ID,
                        productName: current.productName,
                        requiredQuantity: current.qty,
                        expiry: moment(current.expiryTo).format('YYYY-MM-DD'),
                        diN_Master: current.diN_Master,
                        productAvailableQty: current.productAvailableQty,
                        mg: current.mg,
                        packSize_Master: current.packSize_Master,
                        packSizeValue: filterName(packSizeList, current.packSize_ID),
                        dosageValue: filterName(medicationTypeList, current.dosage_ID),
                        productDetail_ID: current.productDetail_ID,
                        productQtySent: current.productQtySent,
                    });
                }
                return acc;
            }, []);
            setProducts(result)
        });
    }

    const getComments = () => {
        setIsLoading(true)
        let obj =
        {
            "sid": null,
            "lid": null,
            "reqInfo": null,
            "msgType": "GETALLCOMMENTSBYRFID",
            "data": { "RFTS_ID": data?.rftsid },
            "debug": null,
            "token": null
        }
        dispatch(getReports(obj)).then(res => {
            let comments = res.payload?.data
            setCommentsList(comments)
            setIsLoading(false)
        })
    }

    const exportInventory = () => {
        setIsExportLoading(true)
        const MainPromise = new Promise((resolve, reject) => {
            const result = Products.map(item => ({
                DIN_Number: item.diN_Master,
                Product_Name: item.productName,
                Strength: item.mg,
                Available_Quantity: item.productAvailableQty,
                Requested_Quantity: item.requiredQuantity,
                PackSize: item.packSizeValue,
                Expiry: item.expiry,
                Received_Quantity: item.productQtySent,
            }))
            setIsExportLoading(false)
            resolve(result)
        });
        return MainPromise;
    }


    const addComment = () => {
        setIsCommentLoading(true)
        let obj =
        {
            "sid": null,
            "lid": null,
            "reqInfo": null,
            "msgType": "INSERTRFTSCOMMENTS",
            "data": { "RFTS_ID": data?.rftsid, "CreateBy": user?.userId, 'Comments': watch('comment') },
            "debug": null,
            "token": null
        }
        dispatch(getReports(obj)).then(res => {
            const record = res.payload?.data?.Data[0]
            let arr = [...commentsList]
            arr.push({
                ...record,
                username: user?.userName
            })
            setCommentsList(arr)
            reset({
                comment: "",
            })
            setIsCommentLoading(false)
        })
    }

    return <>
        <ExportButton data={exportInventory} name={`${data.pharmacyName}_${data.requestDate}`} isExportLoading={isExportLoading} />
        <TableContainer tableHeader={tableHeader}
            data={Products}
            verifyParam={verifyParam}
            isLoading={isLoading}
        />
        <Box sx={{ margin: '10px 0px' }}>
            <Box sx={{ padding: '10px', backgroundColor: '#cab2e8' }}>
                <Typography sx={{ fontSize: '15px', fontWeight: 600 }}>Comments</Typography>
            </Box>

            <Box sx={{ border: '2px solid rgb(237, 231, 246)', padding: '0px 10px' }}>
                {
                    isLoading ? <Box className='tableLoadingContainer'>
                        <CircularProgress size={50} sx={{ margin: '20px' }} />
                    </Box>
                        : <Box ref={scrollRef} sx={{ margin: '10px 0px', maxHeight: '200px', overflow: 'scroll' }}>
                            {
                                commentsList.map(ele => (
                                    <Box sx={{
                                        display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px',
                                        border: '1px solid #eee',
                                        padding: '5px',
                                        margin: '5px',
                                        borderRadius: '5px'
                                    }}>
                                        <Box>
                                            <Typography sx={{ fontWeight: 600 }}>{ele.username}</Typography>
                                            <Typography variant="body2">{ele.comments}</Typography>
                                        </Box>
                                        <Typography sx={{ fontSize: '10px', fontWeight: '300' }}>{moment(ele.createdOn).format('DD MMM, h:m a')}</Typography>
                                    </Box>
                                ))
                            }
                        </Box>}
                <Box sx={{ display: 'flex', alignItems: 'start', gap: '10px' }}>
                    <TextAreaFields
                        fieldName="comment"
                        type="text"
                        label="Comment"
                        control={control}
                        rows={2}
                    />
                    <Box sx={{ paddingTop: '10px' }}>
                        <ButtonContainer isSingle>
                            <Button disabled={isCommentLoading || watch('comment').trim().length == 0} size="medium" variant="contained" color="primary" onClick={handleSubmit(addComment)} >
                                {isCommentLoading && (
                                    <CircularProgress size={20} sx={{ marginRight: 1, color: "#fff" }} />
                                )}
                                Send</Button>
                        </ButtonContainer>
                    </Box>
                </Box>
            </Box>
        </Box>
    </>
};

export default RftsDetailView;
